const e=["https:"];function a(t){try{const o=new URL(t,window.location.origin),n=[window.location.hostname];return e.includes(o.protocol.toLowerCase())&&n.includes(o.hostname)}catch{return!1}}export{a as isValidPath};
//# sourceMappingURL=isValidPath.js.map
